/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DESKTOP_BREAKPOINT = 1023;
var BaseCarousel = function () {
  function BaseCarousel(selector, mobileOnly, showCardCount, jsonOptions) {
    _classCallCheck(this, BaseCarousel);
    this.carouselList = document.querySelectorAll(selector);
    this.jsonOptions = jsonOptions;
    var isMobile = window.innerWidth < DESKTOP_BREAKPOINT;
    if (this.carouselList.length > 0 && (isMobile && mobileOnly || !mobileOnly)) {
      this.splideElements = this.getSplideElements();
      this.splides = this.getSplides();
      this.initSplides();
      this.setSplideListeners();
      if (showCardCount) {
        this.setCardCountNumbers();
      }
    }
  }
  return _createClass(BaseCarousel, [{
    key: "setCardCountNumbers",
    value: function setCardCountNumbers() {
      var _this = this;
      this.carouselList.forEach(function (carousel, carouselIndex) {
        var slideCountElement = carousel.querySelector('.slide-count');
        var ofTextField = carousel.querySelector('.of-text');
        var ofText = ofTextField ? ofTextField.textContent : '';
        var currentSplide = _this.splides[carouselIndex];
        if (slideCountElement) {
          slideCountElement.textContent = "".concat(currentSplide.index + 1, " ").concat(ofText, " ").concat(currentSplide.length);
        }
      });
    }
  }, {
    key: "getSplideElements",
    value: function getSplideElements() {
      var splides = [];
      this.carouselList.forEach(function (carousel) {
        splides.push(carousel.querySelector('.splide'));
      });
      return splides;
    }
  }, {
    key: "setSplideListeners",
    value: function setSplideListeners() {
      var _this2 = this;
      if (this.carouselList.length > 0) {
        this.splides.forEach(function (splide) {
          splide.on('moved', function () {
            _this2.setCardCountNumbers();
          });
        });
      }
    }
  }, {
    key: "getSplides",
    value: function getSplides() {
      var _this3 = this;
      var splides = [];
      this.splideElements.forEach(function (splide) {
        if (splide) {
          splides.push(new Splide(splide, _this3.jsonOptions));
        }
      });
      return splides;
    }
  }, {
    key: "initSplides",
    value: function initSplides() {
      if (this.carouselList.length > 0) {
        this.splides.forEach(function (splide) {
          splide.mount();
        });
      }
    }
  }]);
}();
export { BaseCarousel as default };